import gql from "graphql-tag";

const getLoyaltyMilestones = (schema) => gql`
  query getLoyaltyMilestones($sfid: String!, $isSpanish: Boolean!) {
    salesforce_bll_milestone__c(
      where: { bll_donation_center__c: { _eq: $sfid } }
    ) {
      id
      name
      sfid
      bll_active__c
      bll_type__c
      bll_points__c
      bll_top_earn_activity_order__c
      bll_donation_center__c
      bll_number_of_donations__c
      bll_milestone_icon_url__c @skip(if: $isSpanish)
      bll_milestone_icon_url__c: bll_milestone_url_spanish__c
        @include(if: $isSpanish)
      bll_milestone_title__c @skip(if: $isSpanish)
      bll_milestone_title__c: bll_milestone_title_spanish__c
        @include(if: $isSpanish)
      bll_milestone_sub_title__c @skip(if: $isSpanish)
      bll_milestone_sub_title__c: bll_milestone_sub_title_spanish__c
        @include(if: $isSpanish)
    }
  }
`;

export default getLoyaltyMilestones;
